/**
 * useStableAccessToken — ensures the access token reference doesn't change
 * on every render, preventing cascading re-renders and query re-fetches.
 *
 * This hook memoizes the access token string so consumers (like useSubscriptionsQuery)
 * have a stable reference even if the upstream tokens object reference changes.
 * The stable token prevents queryKey churn and unnecessary React Query invalidations.
 */
import { useMemo } from 'react';

export function useStableAccessToken(accessToken: string | null): string | null {
  // Memoize based on the actual token value, not the reference.
  // If the token string itself doesn't change, the memoized value is stable.
  return useMemo(() => accessToken, [accessToken]);
}
